import { render, staticRenderFns } from "./JCRecord.vue?vue&type=template&id=61e3251c&scoped=true&"
import script from "./JCRecord.vue?vue&type=script&lang=js&"
export * from "./JCRecord.vue?vue&type=script&lang=js&"
import style0 from "./JCRecord.vue?vue&type=style&index=0&id=61e3251c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3251c",
  null
  
)

export default component.exports